"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isZeroDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var isZeroDependencies = exports.isZeroDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createIsZero: _factoriesAny.createIsZero
};